"use client";

import React from "react";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { SearchPagination } from "@ama-pt/agora-design-system";
import { useTranslations } from "next-intl";

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
}

export default function PaginationControls({
  totalPages,
}: PaginationControlsProps) {
  const t = useTranslations('Pagination');
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handlePageChange = (page: number) => {
    if (page < 1) return;

    // SearchPagination fires onChange(1) on mount — skip if already on that page.
    const current = parseInt(searchParams?.get('page') || '1', 10);
    if (page === current) return;

    const params = new URLSearchParams(searchParams?.toString());
    params.set('page', page.toString());
    router.push(`${pathname}?${params.toString()}`);
  };

  return (
    <SearchPagination
      totalPages={totalPages}
      onChange={handlePageChange}
      boundaryCount={1}
      siblingCount={1}
      label={t("navigation")}
      nextPageAriaLabel={t("nextpage")}
      previousPageAriaLabel={t("previousPage")}
    />
  );
}
